import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id EE6C5398-B666-4BE6-9728-AF35B5C77BA9
 * name arrow-u-down-left-bold
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-down-left-bold.svg
 * tags
 */
export const ArrowUDownLeftBoldIcon = createSvgIcon(<><path d="M21 10.5V18H17V10.5C17 8.57 15.43 7 13.5 7S10 8.57 10 10.5V13H14L8 20L2 13H6V10.5C6 6.36 9.36 3 13.5 3S21 6.36 21 10.5Z" /></>, 'ArrowUDownLeftBoldIcon');
export default ArrowUDownLeftBoldIcon